<template>
  <div>
    <h2>FAQ</h2>
    <div class="faq-input-form" v-if="isEditing">
      <div class="form-group">
        <label>
          <p>タイトル</p>
          <input type="text" v-model="faq.title" class="form-group__input" />
        </label>
        <br />
        <ul>
          <li
            v-for="(item, index) in faq.items"
            :key="index"
            class="form-group__item"
          >
            <p class="form-group__row">
              Q:
              <input
                type="text"
                v-model="item.question"
                class="form-group__input"
              />
            </p>
            <p class="form-group__row">
              A:
              <input
                type="text"
                v-model="item.answer"
                class="form-group__input"
              />
            </p>
            <button @click="removeItem(index)">削除</button>
          </li>
        </ul>
        <button @click="addItem" class="form-group__add">質問を追加</button>
      </div>
      <div class="form-group__footer">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="faq-input-preview input-preview" v-else>
      <div class="faq">
        <p class="faq__text">タイトル: {{ faq.title }}</p>
        <div class="faq__items">
          <p>質問リスト</p>
          <ul>
            <li v-for="(item, i) in faq.items" :key="i" class="faq__item">
              <p>Q: {{ item.question }}</p>
              <p>A: {{ item.answer }}</p>
            </li>
          </ul>
        </div>
      </div>
      <footer-menu
        :onDeleteInput="onDeleteInput"
        :onBeginEdit="onBeginEdit"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import FooterMenu from '../input-footer-menu.vue';

export default {
  name: 'FaqEditor',
  components: {
    FooterMenu,
  },
  props: {
    value: Object,
    index: Number,
    id: String,
  },
  data() {
    return {
      isEditing: false,
      faq: {
        title: this.value.title,
        items: this.value.items,
      },
    };
  },
  computed: {
    bodyJSON() {
      const value = {
        title: this.faq.title,
        items: this.faq.items,
      };
      return {
        value,
        action: 'faq',
        id: this.id,
      };
    },
    editorOptions() {
      return {
        modules: {
          table: true,
          toolbar,
        },
      };
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (this.faq.title.length === 0) {
        alert('タイトルを入力してください');
        return false;
      }
      if (this.faq.items.length === 0) {
        alert('質問と回答を入力してください');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
    addItem() {
      this.faq.items = [
        ...this.faq.items,
        {
          question: '',
          answer: '',
        },
      ];
    },
    removeItem(index) {
      this.faq.items = this.faq.items.filter((_, i) => i !== index);
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-input-form {
  background-color: #eee;
  position: relative;
  padding: 15px 15px 1px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}

.form-group {
  &__add {
    margin: 12px 0;
  }

  &__item {
    width: 100%;
    padding: 12px 0;
    margin: 0;
    border-bottom: 1px solid black;
  }

  &__row {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 4px;
    gap: 8px;
  }

  &__input {
    width: 100%;
  }

  &__footer {
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.ql-editor {
  font-size: 15px;
}

.faq {
  border: 1px solid lightgrey;
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;

  &__head {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__text {
    margin-top: 12px;
  }

  &__items {
    margin-top: 12px;
  }

  &__item {
    margin-top: 8px;
    margin-left: 12px;

    > p:nth-child(n + 2) {
      margin-top: 8px;
    }

    &:nth-child(n + 2) {
      border-top: 1px dotted gray;
      padding-top: 8px;
    }
  }
}
</style>
